module.exports = __webpack_public_path__ + "img/default_event_background.30357de7.jpg";